import MainLayout from '@/layout/main/MainLayout.vue';

const router = {
    path: '/system',
    component: MainLayout,
    name: '/system',
    redirect: '/system/userAccount',
    meta: {
        title: '组织管理',
        showFlag: true,
        icon: 'form',
        i18n: `用户管理`,
    },
    children: [
        {
            path: 'userAccount',
            name: '/system/userAccount',
            component: () => import(/* webpackChunkName: "form" */ '@/views/system/userAccount.vue'),
            meta: {
                title: '用户管理',
                showFlag: true,
                i18n: `menu.system.userAccount`,
                flag:true
            },
        }
        ],
};

export default router;
